import Plyr from 'plyr';

export default function initPlayer() {
	const btns = document.querySelectorAll('[data-video]');
	const youtube = document.querySelectorAll('[data-youtube]');
	const player = document.querySelector('.player');
	const close = document.querySelector('.player__close');

	if(document.querySelector('[data-video]') || document.querySelector('[data-youtube]')) {
		const p = new Plyr('#player', {
			fullscreen: { enabled: true, fallback: true, iosNative: true, container: null }
		});

		btns.forEach(btn => {
			btn.addEventListener('click', () => {
				if(btn.dataset.youtube) return false;

				player.classList.add('show');

				p.source = {
				  type: 'video',
				  sources: [
				    {
				      src: btn.dataset.video,
				      type: 'video/mp4',
				    }
				  ],
				};

				p.play();

				// if(window.innerWidth <= 991) {
				// 	setTimeout(function() {
				// 		p.fullscreen.enter();
				// 	}, 1000);
				// }
			});
		});

		youtube.forEach(btn => {
			btn.addEventListener('click', () => {

				player.classList.add('show');

				p.source = {
				  type: 'video',
				  sources: [
				    {
				      src: btn.dataset.youtube.split("v=")[1].split("&")[0],
				      provider: 'youtube',
				    },
				  ],
				};

				setTimeout(function() {
					p.play();
				}, 1000);
			});
		})


		close.addEventListener('click', () => {
			p.stop();

			player.classList.remove('show');
		});

		
	}
}